import { put } from "redux-saga/effects";
import { actions } from "../actions";
import { Payment } from "redmond";
import { listPaymentMethods } from "../../../api/v1/payments/listPaymentMethods";

export function* listPaymentMethodsSaga(_: actions.IListPaymentMethods) {
  try {
    const paymentMethods: Payment[] = yield listPaymentMethods();

    yield put(
      actions.setPaymentMethods({
        paymentMethods,
      })
    );
  } catch (e) {
    yield put(actions.setPaymentMethodsCallStateFailed());
  }
}
